import { DateTime } from 'luxon';

import HeaderBidderConfigPipelineNode, {
  IHeaderBidderConfigPipelineNodeAPI,
} from '@/common/models/headerBidder/HeaderBidderConfigPipelineNode';
import HeaderBidderConfigSSP, { IHeaderBidderConfigSSPAPI } from '@/common/models/headerBidder/HeaderBidderConfigSSP';
import Validatable from '@/validator/Validatable';

interface IHeaderBidderConfigAPI {
  ssps: IHeaderBidderConfigSSPAPI[];
  pipeline: IHeaderBidderConfigPipelineNodeAPI[];
}

export default class HeaderBidderConfig extends Validatable {
  ssps: HeaderBidderConfigSSP[];

  pipeline: HeaderBidderConfigPipelineNode[];

  timestamp: DateTime;

  constructor(ssps: HeaderBidderConfigSSP[] = [], pipeline: HeaderBidderConfigPipelineNode[] = []) {
    super();
    this.ssps = ssps;
    this.pipeline = pipeline;
    this.timestamp = DateTime.local();
  }

  static fromApi(apiObject: IHeaderBidderConfigAPI): HeaderBidderConfig {
    return new HeaderBidderConfig(
      apiObject.ssps.map((x) => HeaderBidderConfigSSP.fromApi(x)),
      apiObject.pipeline.map((x) => HeaderBidderConfigPipelineNode.fromApi(x)),
    );
  }

  toApi(): IHeaderBidderConfigAPI {
    return {
      ssps: this.ssps.map((x) => x.toApi()),
      pipeline: this.pipeline.map((x) => x.toApi()),
    };
  }

  static validatorCreateRules(): Record<string, string> {
    return {};
  }

  static get customFieldKeysStartsWith(): string {
    return 'header-bidder';
  }
}
